import React from 'react';
import T from 'prop-types';
// components
import Typography from 'components/Typography';
// styles
import classnames from 'classnames/bind';
import styles from './Indicator.module.scss';

const cx = classnames.bind(styles);

const ScorePercentageIndicator = ({ score }) => {
  return (
    <div className={cx('score-wrapper', { correct: score >= 0.5 })}>
      <Typography>{Math.floor(score * 100)}% correct</Typography>
    </div>
  );
};

ScorePercentageIndicator.propTypes = {
  score: T.number,
};

export default ScorePercentageIndicator;
